import { QueryClient } from '@tanstack/react-query';
export const defaultExponentialBackoffRetryDelay = (attempt) => {
    const maxDelay = Math.min(2 ** attempt * 500, 30000);
    return Math.floor(Math.random() * maxDelay);
};
/**
 * WARNING: This queryClient should only be accessed directly when prefetching
 * queries outside of the react-tree (such as in before render or react-router loader methods)
 * All other use cases should use the useQueryClient hook.
 */
export const queryClient = new QueryClient({
    // Although networkMode is a great idea in theory, headless selenium tests trick react-query
    // into thinking there is no network connection and all queries are 'paused'
    // https://tanstack.com/query/v4/docs/react/guides/network-mode
    defaultOptions: {
        queries: {
            cacheTime: Infinity,
            staleTime: Infinity,
            networkMode: 'always',
            retry: false, // don't retry on failure
            refetchOnWindowFocus: false, // don't refetch when a window/tab is refocused
            refetchOnReconnect: false, // don't refetch if the user regains internet connection
        },
    },
});
//# sourceMappingURL=query_client.preenvesnextjs.map
